import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-car",
  "use": "spr-car-usage",
  "viewBox": "0 0 12 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 9\" id=\"spr-car\"><defs><path id=\"spr-car_a\" d=\"M1150.5 620.14a.51.51 0 0 1-.5-.52c0-.29.22-.52.5-.52h.95c.44-.77.86-1.5 1.31-2.2.39-.6.59-.72 1.04-.8.66-.1 1.28-.15 2.2-.15.92 0 1.54.05 2.2.16.45.07.65.2 1.04.8.45.69.87 1.42 1.23 2.03l.08.16h.95c.28 0 .5.23.5.52 0 .29-.22.52-.5.52h-.5v4.2c0 .28-.22.52-.5.52a.51.51 0 0 1-.5-.53v-1.04h-8v1.04c0 .3-.22.53-.5.53a.51.51 0 0 1-.5-.53v-4.19zm9.13-.62c-.37-.64-.78-1.35-1.22-2.03a1.42 1.42 0 0 0-.25-.33l-.11-.02c-.62-.1-1.19-.14-2.05-.14-.86 0-1.43.04-2.05.14l-.12.03c-.01 0-.07.06-.24.32-.44.69-.87 1.42-1.3 2.18-.1.17-.18.32-.22.47h7.86a3.13 3.13 0 0 0-.3-.62zm-5.63 2.2a.51.51 0 0 0-.5-.53c-.28 0-.5.24-.5.53 0 .28.22.52.5.52s.5-.24.5-.52zm5 0a.51.51 0 0 0-.5-.53c-.28 0-.5.24-.5.53 0 .28.22.52.5.52s.5-.24.5-.52z\" /></defs><use fill=\"#fff\" xlink:href=\"#spr-car_a\" transform=\"translate(-1150 -616)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/car.svg
// module id = 247
// module chunks = 0